
export function getClassList() {
  const year = new Date().getFullYear();
  console.log("届数==", year);
  var list = [];
  for (let index = 0; index < 4; index++) {
    const classNum = year - index;
    list.push({ label: classNum })
  }
  return list
}
export function getBookStatusColor(status) {
  var str = '';
  switch (status) {
    case 0:
      str = "#FF9A2B"
      break;
    case 1:
      str = "#FF9A2B"
      break;
    case 2:
      str = "#999999"
      break;
    case 3:
      str = "#0082F0"
      break;
    case 4:
      str = "#24C31C"
      break;
    case 5:
      str = "#999999"
      break;

    default:
      break;
  }
  return str;
}

export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}
//状态(1:待院系领导审核;2:院系领导审核不通过;3:待教务处审核;4:教务处审核通过;5:教务处审核不通过)
export var getBookStatus = function (status) {
  var str = '';
  switch (status) {
    case 0:
      str = " 未提交 "
      break;
    case 1:
      str = " 待审核 "
      break;
    case 2:
      str = "审核失败"
      break;
    case 3:
      str = " 审核中 "
      break;
    case 4:
      str = "审核通过"
      break;
    case 5:
      str = "审核失败"
      break;

    default:
      break;
  }
  return str;
}